import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { overrideStarterApiNames } from '../../../hooks/upsell/useStarterUpsell';
import { BaseCardBadge } from '../../components/merch-card/BaseCardBadge';
import { useBadges } from '../../hooks/badges/useBadges';
import { useShowUpsellCustomerPlatformMerchCard } from '../../hooks/product/useUpsellCustomerPlatformMerchCard';
import { HubMerchCard } from './cards/HubMerchCard';
import { UpsellCustomerPlatformMerchCard } from './cards/customer-platform/UpsellCustomerPlatformMerchCard';
import { PriorityFeaturesByProductApiName } from './features-display/PriorityFeaturesByProductApiName';
import { MerchCardTitleContainer } from './headings-display/MerchCardTitleContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubMerchCardLayoutUI = ({
  productsConfig
}) => {
  var _productsConfig$START, _badges$upsellApiName, _badges, _badges$professionalA, _badges$enterpriseApi;
  const {
    showUpsell,
    upsellApiName
  } = useShowUpsellCustomerPlatformMerchCard();
  const hasStarter = !!productsConfig.STARTER;
  const starterApiName = (_productsConfig$START = productsConfig.STARTER) === null || _productsConfig$START === void 0 ? void 0 : _productsConfig$START.apiName;
  const professionalApiName = productsConfig.PROFESSIONAL.apiName;
  const enterpriseApiName = productsConfig.ENTERPRISE.apiName;
  const apiNames = hasStarter && starterApiName ? [starterApiName, professionalApiName, enterpriseApiName] : [professionalApiName, enterpriseApiName];
  const apiNamesWithUpsell = hasStarter ? overrideStarterApiNames(apiNames, showUpsell, upsellApiName) : apiNames;
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: apiNamesWithUpsell
  });
  const columnCount = apiNamesWithUpsell.length;
  const starterColumn = 1;
  const professionalColumn = hasStarter ? 2 : 1;
  const enterpriseColumn = hasStarter ? 3 : 2;
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsxs(MerchCardColumns, {
      columns: columnCount,
      hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
      hasBadgeOnLastColumn: hasBadgeOnLastColumn,
      children: [hasStarter && (showUpsell ? /*#__PURE__*/_jsx(UpsellCustomerPlatformMerchCard, {
        productApiName: upsellApiName,
        columnStart: starterColumn,
        hubPageStarterApiName: starterApiName,
        lowerTierMessage: productsConfig.STARTER.lowerTierMessage,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: upsellApiName,
            badgeName: badges === null || badges === void 0 || (_badges$upsellApiName = badges[upsellApiName]) === null || _badges$upsellApiName === void 0 ? void 0 : _badges$upsellApiName.badgeName
          })
        })
      }, upsellApiName) : /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: starterApiName,
        columnStart: starterColumn,
        Subheading: productsConfig.STARTER.Subheading,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: starterApiName,
            badgeName: badges === null || badges === void 0 || (_badges = badges[starterApiName]) === null || _badges === void 0 ? void 0 : _badges.badgeName
          })
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: starterApiName,
          lowerTierMessage: productsConfig.STARTER.lowerTierMessage
        })
      }, starterApiName)), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: professionalApiName,
        columnStart: professionalColumn,
        Subheading: productsConfig.PROFESSIONAL.Subheading,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: professionalApiName,
            badgeName: badges === null || badges === void 0 || (_badges$professionalA = badges[professionalApiName]) === null || _badges$professionalA === void 0 ? void 0 : _badges$professionalA.badgeName
          })
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: professionalApiName,
          lowerTierMessage: productsConfig.PROFESSIONAL.lowerTierMessage
        })
      }, professionalApiName), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: enterpriseApiName,
        columnStart: enterpriseColumn,
        Subheading: productsConfig.ENTERPRISE.Subheading,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: enterpriseApiName,
            badgeName: badges === null || badges === void 0 || (_badges$enterpriseApi = badges[enterpriseApiName]) === null || _badges$enterpriseApi === void 0 ? void 0 : _badges$enterpriseApi.badgeName
          })
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: enterpriseApiName,
          lowerTierMessage: productsConfig.ENTERPRISE.lowerTierMessage
        })
      }, enterpriseApiName)]
    })
  });
};